import StickySidebar from './vendor/sticky-sidebar.js';

(function () {
  var DESKTOP_MIN = 992;
  var GAP = 16;
  var BOTTOM_SPACING = 16;
  var TABS_OVERHANG = 5;
  var RECALC_DELAY = 120;
  var RECALC_SETTLE = 400;

  var sidebar = null;
  var bar = null;
  var barPriceNow = null;
  var barPriceOld = null;

  function panel() {
    return document.querySelector('#card-sticky-scope .product-label');
  }

  function addButton() {
    var form = document.querySelector('#card-sticky-scope .basket_add_button');
    return form ? form.querySelector('button, input[type="submit"]') : null;
  }

  // Nagłówek przykleja się przy przewijaniu i zasłaniałby górę panelu.
  // Mierzymy jego wysokość, a nie stan pozycjonowania — przy starcie strony
  // bywa jeszcze nieprzyklejony, a wysokość ma już docelową.
  function headerHeight() {
    var header = document.getElementById('header-navbar');

    return header ? header.offsetHeight : 0;
  }

  function topOffset() {
    return headerHeight() + GAP;
  }

  // Wysokość nagłówka jest też potrzebna w CSS — przyklejone zakładki muszą
  // zatrzymywać się pod nim.
  function publishHeaderHeight() {
    document.documentElement.style.setProperty('--header-h', headerHeight() + 'px');
  }

  // topSpacing musi być liczbą — biblioteka wstawia tę opcję prosto do
  // style.top i nie rozwija funkcji.
  var lastTopSpacing = null;

  function syncTopSpacing() {
    publishHeaderHeight();

    if (!sidebar) {
      return;
    }

    var value = topOffset();

    if (value !== lastTopSpacing) {
      lastTopSpacing = value;
      sidebar.options.topSpacing = value;
      sidebar.updateSticky();
    }
  }

  // ---- desktop: panel jedzie razem ze stroną, dołem przyklejony do dołu okna ----

  function initSidebar() {
    var el = panel();

    if (!el || sidebar) {
      return;
    }

    sidebar = new StickySidebar(el, {
      topSpacing: topOffset(),
      bottomSpacing: BOTTOM_SPACING,
      // Zakładki appTabsPlugin renderują się w środku #card-left-content,
      // więc ten kontener sięgałby aż za recenzje. Granicą jest wiersz
      // z galerią i panelem.
      containerSelector: '.card .panel-body',
      minWidth: DESKTOP_MIN,
      resizeSensor: true,
    });
  }

  function recalcSidebar() {
    if (!sidebar || window.innerWidth < DESKTOP_MIN) {
      return;
    }

    sidebar.updateSticky();

    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('scroll'));
    });
  }

  function refreshSidebar() {
    if (sidebar && window.innerWidth >= DESKTOP_MIN) {
      setTimeout(recalcSidebar, 250);
    }
  }

  var recalcTimer = null;
  var settleTimer = null;

  function scheduleRecalc() {
    clearTimeout(recalcTimer);
    clearTimeout(settleTimer);

    recalcTimer = setTimeout(function () {
      updateStickyTabs();
      recalcSidebar();

      settleTimer = setTimeout(function () {
        updateStickyTabs();
        recalcSidebar();
      }, RECALC_SETTLE);
    }, RECALC_DELAY);
  }

  function watchHeight(node) {
    if (!node) {
      return;
    }

    var last = node.offsetHeight;

    var observer = new ResizeObserver(function () {
      var height = node.offsetHeight;

      if (Math.abs(height - last) < 1) {
        return;
      }

      last = height;

      scheduleRecalc();
    });

    observer.observe(node);
  }

  function detachModals() {
    var el = panel();

    if (!el) {
      return;
    }

    Array.prototype.forEach.call(el.querySelectorAll('.modal'), function (modal) {
      document.body.appendChild(modal);
    });
  }

  function watchHeights() {
    if (!('ResizeObserver' in window)) {
      return;
    }

    var el = panel();

    watchHeight(el ? el.querySelector('.inner-wrapper-sticky') : null);
    watchHeight(document.querySelector('#card-sticky-scope > .panel-body'));
    watchHeight(document.getElementById('card-left-content'));
  }

  // ---- mobile: pasek z ceną i koszykiem przypięty do dołu ekranu ----

  function priceText(selector) {
    var el = document.querySelector('#card-sticky-scope .prices ' + selector);
    return el ? el.textContent.trim() : '';
  }

  function syncBarPrices() {
    if (!bar) {
      return;
    }

    barPriceNow.textContent = priceText('.price');

    var old = priceText('.old_price');
    barPriceOld.textContent = old;
    barPriceOld.hidden = !old;
  }

  function buildBar() {
    var origin = addButton();

    if (!origin || bar) {
      return;
    }

    bar = document.createElement('div');
    bar.className = 'pc-mobile-bar';
    bar.hidden = true;

    var price = document.createElement('div');
    price.className = 'pc-mobile-bar__price';

    barPriceNow = document.createElement('b');
    barPriceOld = document.createElement('small');

    price.appendChild(barPriceNow);
    price.appendChild(barPriceOld);

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'btn btn-primary pc-mobile-bar__cta';
    cta.textContent = origin.textContent.trim() || origin.value || '';
    cta.disabled = origin.disabled;

    cta.addEventListener('click', function () {
      var target = addButton();

      if (target && !target.disabled) {
        target.click();
      }
    });

    bar.appendChild(price);
    bar.appendChild(cta);
    document.body.appendChild(bar);
    document.body.classList.add('has-pc-mobile-bar');

    syncBarPrices();
    watchOriginButton(origin);
  }

  // Pasek pojawia się dopiero, gdy właściwy przycisk zniknie z ekranu.
  function watchOriginButton(origin) {
    if (!('IntersectionObserver' in window)) {
      bar.hidden = false;
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.hidden = visible || window.innerWidth >= DESKTOP_MIN;
    }, { rootMargin: '0px 0px -80px 0px' });

    observer.observe(origin);
  }

  // ---- zakładki: position:sticky przegrywa z overflow na przodkach,
  // ---- więc przyklejamy je przez fixed sterowany z JS ----

  var tabs = null;
  var tabsAnchor = null;
  var tabsBox = null;
  var tabsHeight = 0;

  function initStickyTabs() {
    // Przyklejamy sam pasek zakładek. Kontener .card-tabs zawiera również
    // .tab-content z treścią, więc nie nadaje się do przyklejenia.
    tabs = document.querySelector('.card .card-tabs .nav-tabs');

    if (!tabs || !tabs.parentNode) {
      return;
    }

    tabsBox = tabs.closest('.card-tabs');

    tabsAnchor = document.createElement('div');
    tabsAnchor.className = 'card-tabs-anchor';
    tabs.parentNode.insertBefore(tabsAnchor, tabs);
    tabsAnchor.appendChild(tabs);

    updateStickyTabs();

    window.addEventListener('scroll', updateStickyTabs, { passive: true });

    // Faza przechwytywania — handler zakładek w appTabsPlugin kończy się
    // przez `return false`, co zatrzymałoby zdarzenie przed nami.
    tabs.addEventListener('click', onTabClick, true);
  }

  // Po zmianie zakładki wracamy do jej górnej krawędzi, żeby treść zaczynała
  // się od początku, a nie w połowie ekranu.
  function onTabClick(e) {
    if (!e.target.closest('a') || !tabsAnchor) {
      return;
    }

    var anchorTop = (tabsBox || tabsAnchor).getBoundingClientRect().top;
    var limit = headerHeight();

    // Tylko gdy pasek zdążył wyjechać nad widok — inaczej klik u góry strony
    // przewijałby niepotrzebnie w dół.
    if (anchorTop >= limit) {
      return;
    }

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: window.pageYOffset + anchorTop - limit,
      behavior: reduced ? 'auto' : 'smooth',
    });
  }

  function updateStickyTabs() {
    if (!tabs || !tabsAnchor) {
      return;
    }

    // Pasek przykleja się bezpośrednio pod nagłówkiem, bez dodatkowej przerwy.
    var limit = headerHeight();
    var boxRect = (tabsBox || tabsAnchor).getBoundingClientRect();
    var content = tabsAnchor.parentNode.querySelector('.tab-content');
    var contentBottom = content ? content.getBoundingClientRect().bottom : Infinity;
    var stuck = tabs.classList.contains('is-stuck');

    if (!stuck) {
      tabsHeight = tabs.offsetHeight;
    }

    // Przyklejamy, dopóki treść zakładki nie przewinie się do końca.
    var stick = boxRect.top <= limit && contentBottom > limit + tabsHeight;

    if (stick) {
      if (!stuck) {
        tabsAnchor.style.height = tabsHeight + 'px';
        tabs.classList.add('is-stuck');
      }

      tabs.style.top = limit + 'px';
      tabs.style.left = tabsAnchor.getBoundingClientRect().left + 'px';
      // Kilka pikseli ponad szerokość kolumny, żeby pasek kończył się równo
      // z krawędzią zdjęć w opisie, a nie przed nią.
      tabs.style.width = (tabsAnchor.offsetWidth + TABS_OVERHANG) + 'px';
    } else if (tabs.classList.contains('is-stuck')) {
      tabs.classList.remove('is-stuck');
      tabs.style.top = '';
      tabs.style.left = '';
      tabs.style.width = '';
      tabsAnchor.style.height = '';
    }
  }

  function onResize() {
    updateStickyTabs();

    if (bar && window.innerWidth >= DESKTOP_MIN) {
      bar.hidden = true;
    }

    syncTopSpacing();
    refreshSidebar();
  }

  function init() {
    if (!document.getElementById('card-sticky-scope')) {
      return;
    }

    detachModals();
    initSidebar();
    watchHeights();
    buildBar();
    initStickyTabs();
    lastTopSpacing = topOffset();
    publishHeaderHeight();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onResize, 200);
    });


    // Biblioteka liczy wysokość panelu raz — trzeba ją przeliczyć po każdym
    // zdarzeniu, które tę wysokość zmienia.
    window.addEventListener('load', function () {
      syncTopSpacing();
      refreshSidebar();
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncTopSpacing();
        refreshSidebar();
      });
    }

    // Zmiana wariantu przelicza cenę i wysokość panelu.
    if (window.jQuery) {
      window.jQuery(document).on('afterOptionsChange', function () {
        syncBarPrices();
        refreshSidebar();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
